import { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import { AuthAxios } from "../Utilities/CommonAxios";
import showToast from "../Utilities/showToast";
import EditIcon1 from "@mui/icons-material/ModeEditOutlineOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CoPassengerDialog from "./AddCoPassenger";
const CoPassanger = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedPassenger, setSelectedPassenger] = useState(null);
  const [coPassengersValues, setcoPassengersValues] = useState({
    coPassengers: [],
  });
   useEffect(() => {
    getCoPassengerList();
  }, []);
  const getCoPassengerList = async () => {
    try {
      const response = await AuthAxios({
        url: "/co_passangers_list",
        method: "post",
        payload: {},
      });

      if (response.status) {
        const data = response.data || [];
        setcoPassengersValues({ coPassengers: data });
        console.log("passengerList", data);
      }else{
        setcoPassengersValues({ coPassengers: [] });
      }
    } catch (error) {
      showToast("error", error.message);
    }
  };
  const CoPassengerDelete = async (passengerId) => {
    try {
      const response = await AuthAxios({
        url: "/co_passangers_delete",
        method: "post",
        payload: {
          passanger_id: passengerId,
        },
      });

      showToast("success", response.message);
      getCoPassengerList();
    } catch (error) {
      showToast("error", error.message);
    }
  };
 
  const handleOpen = () => {
    setSelectedPassenger(null); 
    setOpenDialog(true);
  };

  const handleEdit = (item) => {
    setSelectedPassenger(item);
    setOpenDialog(true);
  };


  const handleDelete = (id) => {
    CoPassengerDelete(id);
    console.log("Passenger deleted:", id);
  };

  
  const handleClose = () => setOpenDialog(false);
  const handleSave = () => {
    getCoPassengerList();
    setOpenDialog(false);
  };
  return (
    <Grid container spacing={2}>
      <Grid size={{ md: 12, xs: 12 }}>
        <Box
          sx={{
            padding: "33px 20px",
            borderRadius: "20px",
            border: "1px solid #e5e5e5",
            backgroundColor: "#fff",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", alignItems: "center", marginBottom: "20px" }}
          >
            <Grid size={{ md: 10, xs: 12 }}>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "17px",
                  fontWeight: 600,
                  textAlign: "left",
                  color: "#0e182b",
                }}
              >
                Co-Passengers
              </Typography>
              <Typography
                sx={{
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "14px",
                  fontWeight: "normal",
                  textAlign: "left",
                  color: "#717182",
                }}
              >
                Manage frequent co-travelers
              </Typography>
            </Grid>
            <Grid size={{ md: 2, xs: 12 }} sx={{ textAlign: "end" }}>
              <Button
                variant="contained"
                onClick={handleOpen}
                sx={{
                  padding: "7px 10px",
                  borderRadius: "7px",
                  backgroundColor: "#ff5714",
                  fontFamily: '"Segoe UI", sans-serif',
                  fontSize: "13px",
                  fontWeight: 500,
                  textAlign: "center",
                  color: "#fff",
                  textTransform: "capitalize",
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#e04e12",
                  },
                }}
              >
                Add Co-Passenger
              </Button>
            </Grid>
            <CoPassengerDialog
              open={openDialog}
              onClose={handleClose}
              onSave={handleSave}
              data={selectedPassenger}
            />
          </Grid>
          {coPassengersValues ? coPassengersValues?.coPassengers?.map((item, index) => {
            const initials = item.name
              ? item.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
                  .toUpperCase()
              : "NA";

            return (
              <Box
                key={index}
                sx={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "solid 1px #e5e5e5",
                  marginTop: "15px",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Grid size={{ md: 9, xs: 8 }}>
                    <Grid sx={{ display: "flex", alignItems: "center" }}>
                      <Grid sx={{ marginRight: "15px" }}>
                        <Typography
                          sx={{
                            padding: "10px",
                            borderRadius: "60px",
                            backgroundColor: "#ececf0",
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: "13px",
                            fontWeight: "600",
                            textAlign: "center",
                            color: "#000",
                            height: "45px",
                            width: "45px",
                            display: "grid",
                            placeContent: "center",
                          }}
                        >
                          {initials}
                        </Typography>
                      </Grid>
                      <Grid>
                        <Typography
                          sx={{
                            fontSize: "15px",
                            fontWeight: "600",
                            color: "#0e182b",
                          }}
                        >
                          {item.name}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "13px",
                            color: "#666",
                          }}
                        >
                          {item.gender} • {item.age} years
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid size={{ md: 3, xs: 4 }}>
                    <Grid
                      sx={{
                        display: "flex",
                        justifyContent: "end",
                        alignSelf: "center",
                      }}
                    >
                      <Grid sx={{ marginRight: "20px" }}>
                        <EditIcon1
                          sx={{ fontSize: "20px", color: "#0e182b" }}
                          onClick={() => handleEdit(item)}
                        />
                      </Grid>
                      <Grid>
                        <DeleteIcon
                          sx={{ color: "#ff5714" }}
                          onClick={() => handleDelete(item.id)} 
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            );
          }):null}

          {/* 
          <Box
            sx={{
              padding: "10px",
              borderRadius: "12px",
              border: "solid 1px #e5e5e5",
              marginTop: "15px",
            }}
           >
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid size={{ md: 9, xs: 8 }}>
                <Grid sx={{ display: "flex", alignItems: "center" }}>
                  <Grid sx={{ marginRight: "15px" }}>
                    <Typography
                      sx={{
                        padding: "10px",
                        borderRadius: "60px",
                        backgroundColor: "#ececf0",
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: "13px",
                        fontWeight: "600",
                        textAlign: "center",
                        color: "#000",
                        height: "45px",
                        width: "45px",
                        display: "grid",
                        placeContent: "center",
                      }}
                    >
                      MA
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={styleCss.ProfileHead}>
                      Priya Sharma
                    </Typography>
                    <Typography sx={styleCss.Subheading}>
                      Female • 28 years
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ md: 3, xs: 4 }}>
                <Grid sx={{ display: "flex", justifyContent: "end" }}>
                  <Grid sx={{ marginRight: "20px" }}>
                    <Link to={"/"}>
                      <EditIcon1 sx={{ fontSize: "20px", color: "#0e182b" }} />
                    </Link>
                  </Grid>
                  <Grid>
                    <Link to={"/"} sx={{ fontSize: "15px" }}>
                      <DeleteIcon sx={{ color: "#ff5714" }} />
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box> */}
          {/* <Box
            sx={{
              padding: "10px",
              borderRadius: "12px",
              border: "solid 1px #e5e5e5",
              marginTop: "15px",
            }}
           >
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid size={{ md: 9, xs: 8 }}>
                <Grid sx={{ display: "flex", alignItems: "center" }}>
                  <Grid sx={{ marginRight: "15px" }}>
                    <Typography
                      sx={{
                        padding: "10px",
                        borderRadius: "60px",
                        backgroundColor: "#ececf0",
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: "13px",
                        fontWeight: "600",
                        textAlign: "center",
                        color: "#000",
                        height: "45px",
                        width: "45px",
                        display: "grid",
                        placeContent: "center",
                      }}
                    >
                      MA
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography sx={styleCss.ProfileHead}>
                      Priya Sharma
                    </Typography>
                    <Typography sx={styleCss.Subheading}>
                      Female • 28 years
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid size={{ md: 3, xs: 4 }}>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignSelf: "center",
                  }}
                >
                  <Grid sx={{ marginRight: "20px" }}>
                    <Link to={"/"}>
                      <EditIcon1 sx={{ fontSize: "20px", color: "#0e182b" }} />
                    </Link>
                  </Grid>
                  <Grid>
                    <Link to={"/"} sx={{ fontSize: "15px" }}>
                      <DeleteIcon sx={{ color: "#ff5714" }} />
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box> */}
        </Box>
      </Grid>
    </Grid>
  );
};

export default CoPassanger;
